// extracted by mini-css-extract-plugin
export default {"modal":"error-modal_modal__w1s8a","info":"error-modal_info__uwh7K","buttons":"error-modal_buttons__zBulM"};